import React from "react";
import cx from "classnames";
import formatCurrency from "Utils/formatCurrency";
import _ from "lodash";

const BillRecap = ({ price, appliedDiscount, title, infoFee, messages = [], className }) => {
  let finalPrice = formatCurrency(price);

  if (appliedDiscount) {
    finalPrice = formatCurrency(appliedDiscount.pricing_eur);
  }

  return (
    <div className={cx("inputFull2", "bg-[--bg] px-2 py-1 flex flex-col", className)}>
      <div className="flex justify-between text-lg font-semibold">
        <div>{title}</div>

        <div className="flex items-center gap-4">
          {appliedDiscount && (
            <div className="flex items-center gap-1">
              <div className="text-sm line-through ">{formatCurrency(price)}</div>
              <span className="text-[--accent] text-sm">-{appliedDiscount.discount_percent}%</span>
            </div>
          )}

          <div className="">{finalPrice}</div>
        </div>
      </div>

      {infoFee && <div className="text-sm text-[--text-a40] mb-4">* {infoFee}</div>}

      {_.compact(messages).map((message) => (
        <div className="text-sm text-[--text-a40]" key={message}>
          {message}
        </div>
      ))}
    </div>
  );
};

export default BillRecap;
